import { render, staticRenderFns } from "./PageComponentSelector.vue?vue&type=template&id=36420a98"
import script from "./PageComponentSelector.vue?vue&type=script&lang=js"
export * from "./PageComponentSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports